module.exports = __webpack_public_path__ + "static/media/about3.51d907fd.jpg";